export default {"src":"/_next/static/media/email.a30672bf.svg","height":53,"width":114,"blurWidth":0,"blurHeight":0};